import { render } from "./CustomerIdTd.vue?vue&type=template&id=4086d9ed&scoped=true"
import script from "./CustomerIdTd.vue?vue&type=script&lang=js"
export * from "./CustomerIdTd.vue?vue&type=script&lang=js"

import "./CustomerIdTd.vue?vue&type=style&index=0&id=4086d9ed&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4086d9ed"]])

export default __exports__